module.exports = __webpack_public_path__ + "img/image27.ef1ed587.png";